import {
  Box,
  Divider,
  Drawer,
  IconButton,
  Link,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { Close } from "@mui/icons-material";

const formatter = new Intl.NumberFormat("it-IT", {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: 2,
});

// il valore può già arrivare formattato dall'API (es. "45 giorni")
const formatValue = (value) =>
  typeof value === "number" ? formatter.format(value) : value;

// informativa e riepilogo costi arrivano come { dataset: [{ label, value }] }
// (stessa forma del satellitare) o direttamente come elenco di righe
const toRows = (section) => {
  const list = Array.isArray(section) ? section : section?.dataset;
  return (list || []).filter(
    (row) =>
      row?.label &&
      row.value !== null &&
      row.value !== undefined &&
      row.value !== "",
  );
};

// la garanzia apre il dettaglio solo se informativa e riepilogo costi
// del dataCollector non sono vuoti
export const getGaranziaDetails = (garanzia) => {
  const dataCollector = garanzia?.dataCollector;
  const informativa = toRows(dataCollector?.informativa);
  const costi = toRows(dataCollector?.riepilogoCosti);
  if (!informativa.length || !costi.length) return null;
  return {
    informativa,
    costi,
    costiLabel: dataCollector.riepilogoCosti?.label || "Riepilogo costi",
    costiTotale: dataCollector.riepilogoCosti?.totalAmount,
  };
};

export const GaranziaNome = ({ garanzia, onOpen }) =>
  getGaranziaDetails(garanzia) ? (
    <Link
      component="button"
      type="button"
      underline="hover"
      onClick={() => onOpen(garanzia)}
      sx={{ fontSize: "inherit", fontWeight: 600, textAlign: "left" }}
    >
      {garanzia.nome}
    </Link>
  ) : (
    <Typography>{garanzia.nome}</Typography>
  );

const Sezione = ({ title, rows, total }) => (
  <Box>
    <Typography variant="subtitle1" fontWeight={700} gutterBottom>
      {title}
    </Typography>
    <Table size="small">
      <TableBody>
        {rows.map(({ label, value }) => (
          <TableRow key={label}>
            <TableCell sx={{ borderBottom: 0, py: 0.75, pl: 0 }}>
              <Typography variant="body2">{label}</Typography>
            </TableCell>
            <TableCell align="right" sx={{ borderBottom: 0, py: 0.75, pr: 0 }}>
              <Typography variant="body2" fontWeight={600}>
                {formatValue(value)}
              </Typography>
            </TableCell>
          </TableRow>
        ))}
        {total !== null && total !== undefined && (
          <TableRow sx={{ bgcolor: "action.selected" }}>
            <TableCell sx={{ py: 1 }}>
              <Typography variant="body2" fontWeight={800}>
                Totale
              </Typography>
            </TableCell>
            <TableCell align="right" sx={{ py: 1 }}>
              <Typography variant="body2" fontWeight={800}>
                {formatValue(Number(total))}
              </Typography>
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  </Box>
);

const GaranziaDrawer = ({ garanzia, open, onClose }) => {
  const details = getGaranziaDetails(garanzia);

  return (
    <Drawer
      anchor="right"
      open={open && !!details}
      onClose={onClose}
      PaperProps={{ sx: { width: { xs: "100%", sm: 480 } } }}
    >
      {details && (
        <Box p={4} display="flex" flexDirection="column" gap={3}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="flex-start"
            gap={2}
          >
            <Box>
              <Typography variant="h4">{garanzia.nome}</Typography>
              {garanzia.descrizione && (
                <Typography variant="body2" color="text.secondary" mt={1}>
                  {garanzia.descrizione}
                </Typography>
              )}
            </Box>
            <Box display="flex" alignItems="center" gap={1}>
              <Typography variant="h4" whiteSpace="nowrap">
                {formatter.format(Number(garanzia.prezzo) || 0)}
              </Typography>
              <IconButton onClick={onClose} aria-label="Chiudi" size="small">
                <Close />
              </IconButton>
            </Box>
          </Box>
          <Divider />
          <Sezione title="Informativa" rows={details.informativa} />
          <Divider />
          <Sezione
            title={details.costiLabel}
            rows={details.costi}
            total={details.costiTotale}
          />
        </Box>
      )}
    </Drawer>
  );
};

export default GaranziaDrawer;
